import { Badge, Button, Card, Col, Row, Space, Typography, notification } from "antd";
import { capitalizeString } from "../../../shared/util";
import { PartitionOutlined, StarOutlined } from "@ant-design/icons";
import Meta from "antd/es/card/Meta";
import { useNavigate } from "react-router-dom";
import { AuthMessages, Capacity, CommonCapacities, RequestStatus, RoleType, TokenType, User } from "../..";
import ConnectionRequest from "../Forms/Modal/ConnectionRequest/Connection-Request";
import RegisterModal from "../Forms/Modal/Register";
import { useEffect, useState } from "react";
import { registerUser } from "../../../controllers/auth";
import { IconType, NotificationPlacement } from "antd/es/notification/interface";
import { ActionsetUser } from "../../../controllers/store/actions/user/actions";
import store from "../../../controllers/store";
import { PropsCapacitiesList } from "../..";
import { saveRequest, sendNotification } from "../../../controllers/connection";
import { RequestConnection } from "../../../models/RequestConnection";
import { useSelector } from "react-redux";
const { Paragraph, Text } = Typography;

const dispatch = store.dispatch;
const CapacitiesList = (data: PropsCapacitiesList) => {
    const user = useSelector((state: any) => {
        return state.user.user;
    });
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [contact, setContact] = useState({} as any);
    const [isModalRegisterOpen, setIsModalRegisterOpen] = useState(false);
    const [notify, setNotification] = useState(false);
    const [api, contextHolder] = notification.useNotification();
    type NotificationType = 'success' | 'info' | 'warning' | 'error';

    const openNotification = (placement: NotificationPlacement) => {
        api.info({
            type: TokenType.success as IconType,
            message: AuthMessages.Title,
            description: AuthMessages.AccountCreated,
            placement,
        });
    };

    const openNotificationWithIcon = (type: NotificationType) => {
        api[type]({
            message: 'UNAB',
            description: 'Solicitud enviada correctamente.',
        });
    };

    useEffect(() => {
        if (notify) {
            openNotification('topRight');
        }

    }, [notify])

    const detail = (param: any, type: string) => {
        navigate(`${param.id}`, { state: { param, type } });
    };

    return (
        <>
            {contextHolder}
            <RegisterModal
                toggleLogin={true}
                visible={isModalRegisterOpen}
                onSuccessLogin={(user: User) => {
                    dispatch(ActionsetUser(user));
                    setIsModalRegisterOpen(false);
                }}
                onCancel={() => setIsModalRegisterOpen(false)}
                onRegister={async (values: any) => {
                    try {
                        const response = await registerUser({
                            ...values, metadata: {
                                role: RoleType.KnowledgeConsumer
                            }
                        });

                        setNotification(true);
                        setIsModalRegisterOpen(false);

                    } catch (error) {
                        setNotification(true);
                        setIsModalRegisterOpen(false);
                    }
                }}
            />
            <ConnectionRequest
                open={isModalOpen}
                onOk={(value: any, text: string) => {
                    const request = new RequestConnection("", text, user.me, {
                        name: contact?.name || '',
                        email: contact?.email || '',
                        organization_name: contact?.organization_name || contact?.name || '',
                        type: contact?.type || '',
                    }, RequestStatus.Pending, value.requestType || '', contact?.type);

                    saveRequest(request);
                    sendNotification(request);
                    setIsModalOpen(false);
                    openNotificationWithIcon('success');
                }}
                onCancel={() => setIsModalOpen(false)}
                contact={{
                    name: contact?.name || '',
                    email: contact?.email || '',
                    organization_name: contact?.organization_name || '',
                    type: contact?.type || ''
                }} />
            <Row gutter={[8, 8]} style={{ width: '100%', textAlign: 'center' }}>
                {data.list.map((item: CommonCapacities) => (
                    <Col key={item.id} xs={24} sm={12} md={8} lg={6}>
                        <Card
                            className='ant-card-conection'
                            hoverable
                            style={{ width: '100%', marginBottom: 30 }}
                        >
                            {item.recommended ? (
                                <Space style={{ position: 'absolute', top: 10, right: 10 }}>
                                    <Badge dot color='green'>
                                        <StarOutlined style={{ fontSize: 16 }} />
                                    </Badge>
                                    Sugerido
                                </Space>
                            ) : (null)}
                            <div className='with-pointer' onClick={() => {
                                if (item.collection_name === Capacity.Products) {
                                    detail(item, item.collection_name);
                                }

                                if (item.collection_name === Capacity.CommonsCapacity) {
                                    detail(item, item.collection_name);
                                }

                                if (item.collection_name === Capacity.Projects) {
                                    detail(item, item.collection_name);
                                }
                            }}>
                                <h3 style={{ margin: 0 }}>
                                    <Paragraph ellipsis={{ rows: 2, expandable: true, symbol: 'Más', tooltip: (item.name || '').toLowerCase() }}>
                                        {capitalizeString(item.name || '')}
                                    </Paragraph>
                                </h3>
                                <br />
                                <Text type="secondary">
                                    <Paragraph style={{ display: 'inline-block', height: '0px' }} ellipsis={{ rows: 2, expandable: true, symbol: 'Más', tooltip: (item.description || '').toLowerCase() }}>
                                        {capitalizeString(item.description || item.typology || '')}
                                    </Paragraph>
                                </Text>
                                <br />
                                <p><PartitionOutlined color='#2a0089' /> {item.type || ''}</p>
                                <br />
                            </div>
                            <Meta title={''} description={<Button className='ant-card-conection-btn' onClick={() => {
                                if (user) {
                                    setIsModalOpen(!isModalOpen);
                                    console.log("items", item);
                                    setContact({ ...item, email: item.contact_email, name: item.contact_name });
                                } else {
                                    setIsModalRegisterOpen(!isModalRegisterOpen);
                                }
                            }} type="primary" block>
                                Conectar
                            </Button>} />
                        </Card>
                    </Col>
                ))}
            </Row>
        </>
    );
}


export default CapacitiesList;